import pageStyles from '../styles/page-common.module.css';

function Error() {
  return (
    <div className={pageStyles.styledPage}>
      Something went wrong. Please try again later.
    </div>
  );
}

export default Error;